export class FloatLabels {
	constructor(selector) {
		this.populatedClass = "populated";
		this.focusedClass = "focused";
		this.elements = [...document.querySelectorAll(selector)];
		this.elements.forEach(element => this.attachElement(element));
	}
	attachElement(element) {
		let input = element.querySelector("textarea, input, select");
		if (input.value) {
			element.classList.add(this.populatedClass);
		}
		input.addEventListener("focus",()=> this.onFocusElement(element));
		input.addEventListener("blur", ()=> this.onBlurElement(element));
		input.addEventListener("keyup", ()=> this.onKeyUpElement(element));
	}
	onFocusElement(element){
		let input = element.querySelector("textarea, input");
		element.classList.add( this.focusedClass );
		
		if( input.value != ""){
			element.classList.add( this.populatedClass );
		}
	}
	onBlurElement(element){
		let input = element.querySelector("textarea, input");
		element.classList.remove( this.focusedClass );
		
		if( input.value == "" ){
			element.classList.remove( this.populatedClass );
		}
	}
	onKeyUpElement(element){
		element.classList.add( this.populatedClass );
	}
}